import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Инвалидный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Вид рекреационного туризма, расчитанного на людей с ограниченными физическими возможностями.</p>
                </div>
            </div>
        </>
    );
}